import { createStore } from 'vuex';
import { defHttp } from '@/axios/http';
const avatar = new URL('@/assets/img/avatar.png', import.meta.url).href;
export default createStore({
  state: {
    token: localStorage.getItem('singlelogin-userToken') || '',
    // 模拟登录token
    simulateToken: localStorage.getItem('singlelogin-simulateToken') || '',
    firstTimeLogin: localStorage.getItem('singlelogin-firstTimeLogin') === 'true' ? true : false,
    existMenu: localStorage.getItem('singlelogin-existMenu') || '',
    rsaToken: localStorage.getItem('singlelogin-useRsaToken') || '',
    userInfo: localStorage.getItem('singlelogin-userInfo')
      ? JSON.parse(localStorage.getItem('singlelogin-userInfo') || '')
      : '',
    language: [
      {
        label: '繁體中文',
        value: 'zh-hk',
      },
      {
        label: '简体中文',
        value: 'zh-cn',
      },
      {
        label: 'English',
        value: 'en',
      },
    ],
    languageValue: localStorage.getItem('singlelogin-language') || 'zh-hk',
    system: [],
    polarFirstLogin: false, // 蓝色平台第一次登录新视频
    polarFirstLoginForm: {}, // 蓝色平台第一次登录新视频
  },
  getters: {
    // 获取token值
    getoken(state) {
      return state.token;
    },
    // 获取token值
    getRsaToken(state) {
      return state.rsaToken;
    },
    // 是否显示用户管理
    getExistMenu(state) {
      return state.existMenu;
    },
    // 获取用户信息
    getUserInfo(state) {
      return state.userInfo;
    },
    // 获取当前语言
    getLanguageValue(state) {
      return state.languageValue;
    },
    getFirstTimeLogin(state) {
      return state.firstTimeLogin;
    },
    getSystem(state) {
      return state.system
    }
  },
  mutations: {
    setToken(state, value) {
      state.token = value.token;
      state.rsaToken = value.rsaToken;
      state.existMenu = value.existMenu;
      state.firstTimeLogin = value.firstTimeLogin;
    },
    setUserInfo(state, value) {
      state.userInfo = value;
    },
    setSwtichLang(state, value) {
      state.languageValue = value;
    },
  },
  actions: {
    // 登陆  存token  获取用户信息
    async setUserToken({ commit }, value) {
      commit('setToken', value);
      const res = await defHttp.get({ url: '/userInfo' });
      const userInfo = { ...res.data, avatarUrl: res.data.avatarUrl ? res.data.avatarUrl : avatar }
      localStorage.setItem(
        'singlelogin-userInfo',
        JSON.stringify(userInfo)
      );
      commit('setUserInfo', userInfo);
    },
    // 登出 移除缓存
    removerToken({ commit }, value) {
      localStorage.removeItem('singlelogin-useRsaToken');
      localStorage.removeItem('singlelogin-userInfo');
      localStorage.removeItem('singlelogin-firstTimeLogin');
      if (this.state.simulateToken) {
        this.state.simulateToken = '';
        localStorage.removeItem('singlelogin-simulateToken');
        window.location.reload()
      } else {
        localStorage.removeItem('singlelogin-userToken');
        commit('setToken', value);
      }
    },
    // 刷新重新調用  用戶信息接口
    async setlocaload({ commit }) {
      if (this.state.token) {
        const res = await defHttp.get({ url: '/userInfo' });
        const userInfo = { ...res.data, avatarUrl: res.data.avatarUrl ? res.data.avatarUrl : avatar }
        localStorage.setItem(
          'singlelogin-userInfo',
          JSON.stringify(userInfo)
        );
        commit('setUserInfo', userInfo);
      }
    },
    // 切换语言
    swtichLang({ commit }, value) {
      localStorage.setItem('singlelogin-language', value);
      commit('setSwtichLang', value);
    },
    // 设置平台
    setSystem(_, value) {
      this.state.system = value
    }
  },
  modules: {},
});
